import { render, staticRenderFns } from "./sesionItem.vue?vue&type=template&id=0d8ed149&"
import script from "./sesionItem.vue?vue&type=script&lang=js&"
export * from "./sesionItem.vue?vue&type=script&lang=js&"
import style0 from "./sesionItem.vue?vue&type=style&index=0&id=0d8ed149&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports